import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverflowSpanComponent } from './overflow-span/overflow-span.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TooltipModule } from '@soti/tooltip';
import { PipesModule, XsI18nPipe } from '@nx-fe/pipes';

@NgModule({
  imports: [CommonModule, MatTooltipModule, TooltipModule, PipesModule],
  declarations: [OverflowSpanComponent],
  exports: [OverflowSpanComponent],
  providers: [XsI18nPipe],
})
export class OverflowSpanModule {}
